import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { getAvailableYears } from '../utils/dateUtils';

interface YearSelectProps {
  value: number;
  onChange: (year: number) => void;
  minWidth?: number;
  fullWidth?: boolean;
}

const YearSelect: React.FC<YearSelectProps> = ({
  value,
  onChange,
  minWidth = 120,
  fullWidth = false,
}) => {
  const years = getAvailableYears();

  const handleChange = (event: SelectChangeEvent<number>) => {
    onChange(event.target.value as number);
  };

  return (
    <FormControl sx={{ minWidth, width: fullWidth ? '100%' : undefined }}>
      <InputLabel>Year</InputLabel>
      <Select value={value} label="Year" onChange={handleChange}>
        {years.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default YearSelect;
